import React from "react";
import { Tooltip } from "antd";
import styles from "./CustomTooltip.module.scss";

type PlacementType =
  | "top"
  | "left"
  | "right"
  | "bottom"
  | "topLeft"
  | "topRight"
  | "bottomLeft"
  | "bottomRight"
  | "leftTop"
  | "leftBottom"
  | "rightTop"
  | "rightBottom";

type TriggerType = "hover" | "focus" | "click" | "contextMenu";

type CustomTooltipProps = {
  tooltipText: string | JSX.Element;
  icon: string;
  placement?: PlacementType;
  className: string;
  trigger?: TriggerType[];
};

const CustomTooltip: React.FC<CustomTooltipProps> = ({
  tooltipText,
  icon,
  placement = "top",
  className,
  trigger = ["hover"],
}) => {
  return (
    <Tooltip
      title={tooltipText}
      placement={placement}
      overlayClassName={styles[className]}
      trigger={trigger}
    >
      <img src={icon} alt="tooltip" />
    </Tooltip>
  );
};

export default CustomTooltip;
